"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const UInt64_1 = require("../UInt64");
const PublicAccount_1 = require("../account/PublicAccount");
class HarvesterMetaInfo {
    constructor(harvesterKey, owner, disabledHeight, lastSigningBlockHeight, effectiveBalance, canHarvest, activity, greed, metaId) {
        this.harvesterKey = harvesterKey;
        this.owner = owner;
        this.disabledHeight = disabledHeight;
        this.lastSigningBlockHeight = lastSigningBlockHeight;
        this.effectiveBalance = effectiveBalance;
        this.canHarvest = canHarvest;
        this.activity = activity;
        this.greed = greed;
        this.metaId = metaId;
    }
    /**
     * @param dto
     * @param networkType
     * @returns
     */
    static createFromDTO(dto, networkType) {
        return new HarvesterMetaInfo(PublicAccount_1.PublicAccount.createFromPublicKey(dto.harvester.key, networkType), PublicAccount_1.PublicAccount.createFromPublicKey(dto.harvester.owner, networkType), new UInt64_1.UInt64(dto.harvester.disabledHeight), new UInt64_1.UInt64(dto.harvester.lastSigningBlockHeight), new UInt64_1.UInt64(dto.harvester.effectiveBalance), dto.harvester.canHarvest, dto.harvester.activity, dto.harvester.greed, dto.meta.id);
    }
}
exports.HarvesterMetaInfo = HarvesterMetaInfo;
//# sourceMappingURL=HarvesterMetaInfo.js.map